import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    indexMenus:[],
    cultureState: false
  },
  mutations: {
    // 存储菜单栏数据
    updateIndexMenus(state, datas) {
      state.indexMenus = datas
    },
    // 改变用户登录状态
    updateCultureState(state, datas) {
      state.cultureState = datas
    }
  },
  actions: {
  },
  modules: {
  }
})